import axios from "axios";
import { type PerformanceWithAccountFilter } from "features/Library/Common/utils/performanceUtils";
import type {
  CopilotUsersTrendPoint,
  CopilotAppEngagementTrendPoint,
  CopilotAppEngagementItem,
  CopilotUserEngagement,
} from "features/Reporting/MsGraph/Copilot/types";

export const COPILOT_USERS_TREND_ENDPOINT = "/api/reports/v1/msft/copilot/users-trend";
export const COPILOT_APP_ENGAGEMENT_TREND_ENDPOINT = "/api/reports/v1/msft/copilot/app-engagement-trend";
export const COPILOT_APP_ENGAGEMENT_ENDPOINT = "/api/reports/v1/msft/copilot/app-engagement";
export const COPILOT_USER_ENGAGEMENT_ENDPOINT = "/api/reports/v1/msft/copilot/user-engagement";

export const copilotReportingService = {
  getUsersTrend(params: PerformanceWithAccountFilter, signal?: AbortSignal) {
    return axios.get<CopilotUsersTrendPoint[]>(COPILOT_USERS_TREND_ENDPOINT, { params, signal });
  },

  getAppEngagementTrend(params: PerformanceWithAccountFilter, signal?: AbortSignal) {
    return axios.get<CopilotAppEngagementTrendPoint[]>(COPILOT_APP_ENGAGEMENT_TREND_ENDPOINT, { params, signal });
  },

  getAppEngagement(params: PerformanceWithAccountFilter, signal?: AbortSignal) {
    return axios.get<CopilotAppEngagementItem[]>(COPILOT_APP_ENGAGEMENT_ENDPOINT, { params, signal });
  },

  getUserEngagement(params: PerformanceWithAccountFilter, signal?: AbortSignal) {
    return axios.get<CopilotUserEngagement>(COPILOT_USER_ENGAGEMENT_ENDPOINT, { params, signal });
  },
};
